import CircleCheck from '../../src/legacy/CircleCheck';
export default CircleCheck;
